import React, { forwardRef, useImperativeHandle, useState } from "react";
import PropTypes from "prop-types";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Snackbar,
  Switch,
} from "@mui/material";
import { deleteUser } from "../../../services/user";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";

const DialogDeleteForwardRef = (props, ref) => {
  const { user } = props;

  const navigate = useNavigate();

  useImperativeHandle(ref, () => ({
    open() {
      setDeleteDialogOpen(true);
    },
  }));

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarColor, setSnackbarColor] = useState("success");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [checked, setChecked] = useState(false);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarMessage("");
  };

  const handleDeleteDialogAgree = () => {
    deleteUser(user.id)
      .then((response) => {
        if (response.data.success) {
          setSnackbarMessage("Sikeresen törölted a felhasználót!");
          setSnackbarOpen(true);
          setTimeout(() => {
            window.history.back();
          }, 2000);
        } else {
          setSnackbarColor("error");
          setSnackbarMessage(response.data.message);
          setSnackbarOpen(true);
        }
      })
      .catch((err) => console.error(err));
    setDeleteDialogOpen(false);
  };
  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <>
      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteDialogClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          {"Felhasználó fizikai törlés"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText component={"div"} id="delete-dialog-description">
            <Grid container direction={"column"} spacing={0}>
              <Grid>Biztosan törölni akarod a felhasználót?</Grid>
              <Grid>
                <FormControlLabel
                  required
                  control={<Switch checked={checked} onChange={handleChange} />}
                  label="Megerősítés"
                />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color={"error"}>
            Nem
          </Button>
          <Button
            onClick={handleDeleteDialogAgree}
            variant={"contained"}
            color={"success"}
            autoFocus
            disabled={!checked}
          >
            Igen
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={6000}
        open={snackbarOpen}
        message={snackbarMessage}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarColor}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

const DialogDelete = forwardRef(DialogDeleteForwardRef);

DialogDelete.propTypes = {
  user: PropTypes.object.isRequired,
};

export default DialogDelete;
